// ----------------------------------------------------------------------

const account = {
  displayName: 'Renaud Obama',
  email: 'me@projectPartners.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
